import { render, staticRenderFns } from "./DeleteDraggingButton.vue?vue&type=template&id=ff8913b0&scoped=true"
import script from "./DeleteDraggingButton.vue?vue&type=script&lang=js"
export * from "./DeleteDraggingButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteDraggingButton.vue?vue&type=style&index=0&id=ff8913b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8913b0",
  null
  
)

export default component.exports